import { useRef, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import logo from '@assets/images/logo.webp';



export const AdminHeader = () => {
	const { t } = useTranslation('admin');

	const { pathname } = useLocation();
	const headerRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		headerRef?.current?.scrollIntoView();
	}, [ pathname, headerRef ]);

	return (
		<div className='app-admin-header' ref={headerRef}>

			<div className='header-section logo-section'>
				
				<Link to={NavigateRoutesEnum.basePath} className='main-logo disable-selection'>
					<img src={logo} alt='main-logo' />
				</Link>
			
			</div>

			<h1>{t('header')}</h1>
			
		</div>
	);
}